import React, { useEffect, useState } from "react";
import { Button, Col, Row, Form } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { DeliveryTable } from "./DeliveryTable";
import { useSelector, useDispatch } from "react-redux";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchAll,
  fetchStatusParam,
  selectStatusParam,
} from "./deliverySlice";
import Select from "react-select";
import { useParams } from "react-router-dom";

import {
  useForceUpdate,
  showErrorDialog,
  getValueOptions,
} from "../../utility";
import { useLocalStorage } from "../../utility/useLocalStorage";
import { TrendingUpRounded } from "@material-ui/icons";
import {
  fetchSettingId,
  selectSettingId,
} from "../administrator/general-setting/generalSettingSlice";

export const DeliveryPage = (params) => {
  const dispatch = useDispatch();
  const data = useSelector(selectData);
  const dataSettingId = useSelector(selectSettingId);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const statusParam = useSelector(selectStatusParam);

  const forceUpdate = useForceUpdate();

  // Filter
  const [retNumber, setRetNumber] = useLocalStorage("retNumber", "");
  const [status, setStatus] = useLocalStorage("status", "");
  const [invoiceNo, setInvoiceNo] = useLocalStorage("invoiceNo", "");
  const [customerName, setCustomerName] = useLocalStorage("customerName", "");
  const [customerCode, setCustomerCode] = useLocalStorage("customerCode", "");
  const [statusPrint, setStatusPrint] = useState("");
  const [typeReturn, setTypeReturn] = useState("");
  const [reloadGet, setReloadGet] = useState(false);

  const { id } = useParams();

  const cutoff = dataSettingId?.plants || [];

  console.log(cutoff, "cutoff");

  useEffect(() => {
    // Reset on first load
    dispatch(resetData());

    dispatch(
      fetchStatusParam({
        paramGroupId: "STATUS_PRINT",
        pageNo: 1,
        pageSize: 20,
      })
    );

    dispatch(fetchSettingId("cut.off.fareye"));
  }, [dispatch]);

  useEffect(() => {
    if (id != null) {
      dispatch(
        fetchAll({
          stepCode: "CD",
          group: true,
          retNumber: id,
          pageNo: pageNo,
          pageSize: pageSize,
        })
      );
    }
  }, [id]);

  useEffect(() => {
    const cekGet = params.location.state;
    if (cekGet === true) {
      setReloadGet(true);
    }
  }, []);

  useEffect(() => {
    async function fetchMyAPI() {
      if (reloadGet === true) {
        try {
          const response = await dispatch(
            fetchAll({
              stepCode: "CD",
              group: true,
              retNumber: retNumber,
              invoiceNo: invoiceNo,
              // statusPrint: statusPrint,
              customerName: customerName,
              statusPrint: status,
              pageNo: pageNo,
              pageSize: pageSize,
            })
          );
          setReloadGet(false);
          if (response.payload.status === 200) {
            setReloadGet(false);
          } else {
            showErrorDialog(response.payload.message);
          }
        } catch (error) {
          showErrorDialog("eror something wrong");
        }
      }
    }
    fetchMyAPI();
  }, [reloadGet]);
  console.log(reloadGet, "reloadget");

  const handleStatusChange = (value) => {
    setStatus(value.value);
    forceUpdate();
  };

  // const statusOptions = statusParam.map((e) => {
  //   return {
  //     value: e.paramCode,
  //     label: e.paramValue,
  //   };
  // });

  const statusOptions = [
    { value: "", label: "All" },
    ...statusParam.map((e) => {
      const item = {};
      item.value = e.paramCode;
      item.label = e.paramValue;
      return item;
    }),
  ];

  const getValueStatus = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };

  const handleSearch = () => {
    const params = {
      stepCode: "CD",
      group: true,
      retNumber: retNumber.replace(/\s/g, ""),
      invoiceNo: invoiceNo,
      // statusPrint: statusPrint,
      customerName: customerName,
      customerCode: customerCode,
      statusPrint: status,
      typeReturn: typeReturn,
      pageNo: 1,
      pageSize: 10,
    };
    dispatch(fetchAll(params));
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    const params = {
      stepCode: "CD",
      group: true,
      retNumber: retNumber.replace(/\s/g, ""),
      invoiceNo: invoiceNo,
      // statusPrint: statusPrint,
      customerName: customerName,
      customerCode: customerCode,
      statusPrint: status,
      typeReturn: typeReturn,
      pageNo: page,
      pageSize: sizePerPage,
    };
    dispatch(fetchAll(params));
  };

  const selectedParam = {
    stepCode: "CD",
    group: true,
    retNumber: retNumber,
    invoiceNo: invoiceNo,
    statusPrint: statusPrint,
    customerName: customerName,
    pageNo: pageNo,
    pageSize: pageSize,
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const [name, setName] = useState(() => {
    // getting stored value
    const saved = localStorage.getItem("name");
    const initialValue = JSON.parse(saved);
    return initialValue || "";
  });

  const typeReturnOptions = [
    { value: "", label: "All" },
    { value: "MTKA", label: "With RTV" },
    { value: "NON MTKA", label: "Without RTV" },
  ];

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="Chief Delivery"></CardHeader>
      <CardBody>
        {/* Filter */}
        <Form>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>APL Return Number </b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="APL Return Number "
                    onChange={(e) => {
                      setRetNumber(e.target.value);
                    }}
                    onKeyPress={handleKeyPress}
                    value={retNumber}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Invoice Ref Num</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Invoice No"
                    onChange={(e) => {
                      setInvoiceNo(e.target.value);
                    }}
                    onKeyPress={handleKeyPress}
                    value={invoiceNo}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Type Return</b>
                </Form.Label>
                <Col sm={5}>
                  <Select
                    options={typeReturnOptions}
                    value={getValueOptions(typeReturn, typeReturnOptions)}
                    // placeholder="Select ..."
                    onChange={(e) => {
                      setTypeReturn(e.value);
                    }}
                    onKeyPress={handleKeyPress}
                  />
                </Col>
              </Form.Group>
            </Col>

            {/* Right Row */}
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Customer Name</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Customer Name"
                    onChange={(e) => {
                      setCustomerName(e.target.value);
                    }}
                    onKeyPress={handleKeyPress}
                    value={customerName}
                  />
                </Col>
              </Form.Group>{" "}
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Customer Code</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Customer Code"
                    onChange={(e) => {
                      setCustomerCode(e.target.value);
                    }}
                    onKeyPress={handleKeyPress}
                    value={customerCode}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Status Print</b>
                </Form.Label>
                <Col sm={5}>
                  <Select
                    options={statusOptions}
                    value={getValueStatus(status, statusOptions)}
                    placeholder="Select Status..."
                    onChange={handleStatusChange}
                  />
                </Col>
              </Form.Group>
            </Col>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Button className="btn btn-primary ml-1" onClick={handleSearch}>
                  Search
                </Button>
              </Col>
            </Form.Group>
          </Form.Group>
        </Form>

        {/* Table */}
        {data && data.length > 0 && (
          <DeliveryTable
            data={data}
            page={pageNo}
            sizePerPage={pageSize}
            totalSize={totalRecord}
            onTableChange={handleTableChange}
            loading={loading}
            params={selectedParam}
            handleSearch={handleSearch}
            cutoff={cutoff}
          />
        )}
      </CardBody>
    </Card>
  );
};
